import classNames from 'classnames';
import ClearBtn from 'src/Components/ClearBtn/ClearBtn';
import { ReactComponent as SearchIcon } from 'src/Themes/assets/search.svg';
import TextHint from 'src/Components/TextHint';
import './TextBox.scss';
import React from 'react';

interface ITextBoxProps extends React.HTMLAttributes<HTMLDivElement> {
	
	value: string;
	setValue: Function;
	isPlaceHolder?: boolean;
	readOnly?: boolean;
	autoFocus?: boolean;
	disabled?: boolean;
	placeholder?: string;
	isClearBtn?: boolean;
	withoutIcon?: boolean;
	isField?: boolean;
	size?: "min" | "std" | "large" | "std32";

	isInvalid?: boolean;

	onClear?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

/**
 * Текстовое поле ввода
 */
const TextBox: React.FC<ITextBoxProps> = (props) => {

	const { isPlaceHolder = false, id, value, setValue, disabled = false, readOnly = false, className, autoFocus = false, isInvalid = false,
		isClearBtn = true, size = "std", withoutIcon = false, placeholder, isField = false, onClick, onClear, ...otherProps 
	} = props;

	const onChangeValueHandler = (e: any) => {
		e.persist();
		if ( !readOnly || e.target.value === '' )
			setValue(e.target.value);
	}

	const onClearHandler = ( e: any ) => {
		e.stopPropagation();
		e.preventDefault();
		if ( isPlaceHolder )
			!!onClear && onClear(e);
		else 
			setValue('');
	}

	const renderContent = () => {
		if ( isPlaceHolder ) {
			return (
				<TextHint className="rdc_control__value" >
					{ value }
				</TextHint>
			);
		}
		else {
			return (
				<input
					id={ "input-" + id}
					readOnly={readOnly || isPlaceHolder}
					value={value || ''}
					autoFocus={autoFocus}
					className={ classNames('rdc-control__input', className )}
					type='text'
					onChange={onChangeValueHandler}
					disabled={disabled}
					placeholder={placeholder}
					onClick={onClick}
				/> 
			);
		}
	};

	const classes = classNames("rdc-control", className, `rdc-control-${size}`, { 
		"rdc-control-placeholder": isPlaceHolder, 
		"rdc-control-field": isField,
		'rdc-control-readonly': readOnly,
		'rdc-control-invalidate': isInvalid
	});

	return (
		<div className={classes} {...otherProps}>
			{ !withoutIcon && <SearchIcon className="rdc-control__ico" /> }
			{ renderContent() }
			{
				(!!isClearBtn && !!value && !disabled) &&
				<ClearBtn id={"clear-" + id} disable={readOnly} className='rdc-control__clear' onClick={onClearHandler} />
			}
		</div>
	);
}

export default TextBox;
